import { api } from './api'
import type { PlayerStatistic } from '@acepoker/contract'

export const getStatistics = async (
  playerId: string,
  sessionId?: string
): Promise<PlayerStatistic> => {
  const searchParams = new URLSearchParams()
  if (sessionId) {
    searchParams.append('sessionId', sessionId)
  }
  const searchString = searchParams.size !== 0 ? `?${searchParams.toString()}` : ''
  const endpoint = `/api/player/${playerId}/statistics${searchString}`
  return await api().get(endpoint).json()
}
